"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var getNestedPropertiesAsStrings = function getNestedPropertiesAsStrings(property) {
  var str = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  if (property.type === _PropertyTypes.default.NESTED) {
    return property.children.reduce(function (acc, child) {
      return acc.concat(getNestedPropertiesAsStrings(child, "" + str + property.key + "/"));
    }, []);
  }

  return ["" + str + property];
};

var _default = getNestedPropertiesAsStrings;
exports.default = _default;
module.exports = exports.default;